module.exports = __webpack_public_path__ + "static/media/route-pro-widget-bg-lg-dark.2c835d1c.png";